import { FC, ReactElement } from "react";
import { Box, Stack } from "@mui/material";
import { tokens } from "@/tokens";

interface IDutiesStackedBar {
  dutiesPaid: number;
  dutiesDue: number;
}

const DutiesStackedBar: FC<IDutiesStackedBar> = ({ dutiesPaid, dutiesDue }): ReactElement => {
  const percentage = dutiesDue > 0 ? (dutiesPaid / dutiesDue) * 100 : 0;

  return (
    <Stack spacing={0.75} mb={1.5}>
      <Box
        sx={{
          width: "100%",
          height: 16,
          bgcolor: tokens.border.default,
          borderRadius: "4px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            left: 0,
            top: 0,
            height: "100%",
            width: `${percentage}%`,
            bgcolor: tokens.status.success,
            borderRadius: "4px",
            transition: "width 0.3s ease",
          }}
        />
      </Box>
    </Stack>
  );
};

export default DutiesStackedBar;